import React, { useCallback, useEffect } from "react";
import Collapsible from "react-collapsible";
import { useDispatch } from "react-redux";
import { FAQ } from "../../../domain/faq/FAQ";
import { Paths } from "../../../Paths";
import { useAppDispatch } from "../../../state/store";
import { deleteFAQAction, getFAQListAction } from "../../../state/usecase/faq/action";
import { useScrollTop } from "../../hooks/common/useScrollTop";
import { useFAQList } from "../../hooks/faq/useFAQList";
import { AdminOnlyComponents } from "../admin/components/AdminOnlyComponents";
import { AddButton } from "../common/button/AddButton";
import { EditButton } from "../common/button/EditButton";
import { RemoveButton } from "../common/button/RemoveButton";
import md from "./components/MarkdownParser";
import { useNavigate } from "react-router-dom";

export function FAQListPage() {
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(getFAQListAction());
    }, [dispatch]);

    useScrollTop();

    const faqList = useFAQList();

    return (
        <div className={"faq_page"}>
            <div className={"container"}>
                <FAQAddButton />
                <FAQList list={faqList} />
            </div>
        </div>
    );
}

const FAQAddButton = React.memo(function FAQAddButton() {
    const navigate = useNavigate();

    const handleClicked = useCallback(() => {
        navigate(`${Paths.admin}${Paths.faq}${Paths.add}`);
    }, [navigate]);

    return <AdminOnlyComponents>
        <div className={"add_button_area"} onClick={handleClicked}>
            <AddButton label="FAQを追加する" onClick={handleClicked} />
        </div>
    </AdminOnlyComponents>;
});

const FAQList = React.memo(function FAQList(props: FAQListProps) {
    const { list } = props;
    return list ? (
        <div className="faq_list">
            {list.map(faq => <FAQItem key={faq.id.value} item={faq} />)}
        </div>
    ) : <></>;
});

const FAQItem = React.memo(function FAQItem(props: FAQItemProps) {
    const { item } = props;

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleEditClicked = useCallback((faq: FAQ) => () => {
        navigate(`${Paths.admin}${Paths.faq}${Paths.edit}/${faq.id.value}`, { state: { title: faq.title.value, content: faq.content.value } });
    }, [navigate]);

    const handleDeleteClicked = useCallback((faq: FAQ) => () => {
        const ok = window.confirm(`FAQ「${faq.title.value}」を削除します。よろしいですか？`);
        if (!ok) return;

        dispatch(deleteFAQAction({ faqId: faq.id.value }));

    }, [dispatch]);

    return (
        <div className="faq_list__item">
            <Collapsible
                className="faq_accordion"
                openedClassName="faq_accordion"
                triggerOpenedClassName="trigger_opened"
                trigger={
                    <div className="faq_accordion__trigger">
                        <div className="qa_mark">Q</div>
                        <div className="faq_accordion__trigger__text">{item.title.value}</div>
                        <img src="/images/icons/accordion_icon.svg" alt="" />
                    </div>
                }
                transitionTime={100}
            >
                <div className="faq_accordion__content">
                    <div className="qa_mark">A</div>
                    {/* eslint-disable-next-line */} {/* '__html'というプロパティ名がeslintルールに引っかかるためeslintをdisabledにする */}
                    <div className="preview" dangerouslySetInnerHTML={{ __html: md.render(item.content.value) }}/>
                </div>
            </Collapsible>
            <AdminOnlyComponents>
                <div className="button_group">
                    {/* 編集 */}
                    <EditButton onClick={handleEditClicked(item)} />
                    {/* 削除 */}
                    <RemoveButton onClick={handleDeleteClicked(item)} />
                </div>
            </AdminOnlyComponents>
        </div>
    );
});

type FAQListProps = {
    list: FAQ[] | null
}

type FAQItemProps = {
    item: FAQ
}
